import React from 'react';
import * as R from 'ramda';
// components
import { TextComponent } from '../text';
// helpers/constants
import * as G from '../../helpers';
// component page-title
import { Wrapper, StatusLabel } from './ui';
//////////////////////////////////////////////////

export const PageTitle = (props) => {
  const {
    mr,
    mb,
    mt,
    count,
    title,
    label,
    zIndex,
    status,
    display,
    withCount,
    showStatus,
    textTransform,
  } = props;

  const titleToUse = G.ifElse(withCount, `${title} (${R.or(count, 0)})`, title);

  return (
    <Wrapper
      mr={mr}
      mb={mb}
      mt={mt}
      p='5px'
      fontSize={14}
      zIndex={zIndex}
      fontWeight={500}
      borderRadius={10}
      display={display}
      position='relative'
      bg={G.getTheme('colors.offWhite')}
      color={G.getTheme('colors.dark.mainDark')}
    >
      <TextComponent
        p='5px 10px'
        maxWidth={300}
        display='block'
        borderRadius={15}
        title={titleToUse}
        withEllipsis={true}
        textTransform={textTransform}
        backgroundColor={G.getTheme('colors.white')}
      >
        {titleToUse}
      </TextComponent>
      {label}
      {showStatus && <StatusLabel status={status}><div /></StatusLabel>}
    </Wrapper>
  );
};
